<div class="confirm-container">
  <div class="header">
    <div class="img-container text-center">
      <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" width="200" />
    </div>
  </div>

  <div class="confirm-content">
    <div class="header">
      <h4>UPDATE MAP IMAGE</h4>
    </div>

    <div class="upload-section">
      @if (selectedImagePreview) {
        <div class="image-preview">
          <img [src]="selectedImagePreview" alt="Selected map image" />
        </div>
      }

      <div class="file-input-wrapper">
        <label for="mapImageInput" class="btn btn-dark">CHOOSE IMAGE</label>
        <input
          type="file"
          id="mapImageInput"
          accept="image/jpeg,image/png,image/jpg"
          (change)="onFileSelected($event)"
          #fileInput
          />
        </div>

        @if (selectedFileName) {
          <p class="file-info">
            Selected: {{ selectedFileName }}
          </p>
        }
      </div>
    </div>

    <div class="btn-sec">
      <button class="btn btn-outline" (click)="close()">Cancel</button>
      <button class="btn btn-theme" (click)="uploadImage()" [disabled]="!selectedFile || isUploading">
        {{ isUploading ? 'UPLOADING...' : 'UPLOAD' }}
      </button>
    </div>
  </div>
